import { useState } from "react";
import { Button } from "@/components/ui/button";
import { BellIcon } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import {
    Dialog,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    SideDialogContent,
} from "@/components/ui/dialog";
import NotificationContent from "../components/notifications/Content";

export default function NotificationDialog() {
    const [open, setOpen] = useState(false);
    return (
        <Dialog open={open} onOpenChange={(value) => setOpen(value)}>
            <DialogTrigger asChild>
                <Button onClick={() => setOpen(true)}>
                    <BellIcon />
                </Button>
            </DialogTrigger>
            <SideDialogContent className="rounded-l-2xl">
                <DialogHeader className="pb-2">
                    <DialogTitle className="text-2xl font-semibold tracking-tight">
                        Notifications
                    </DialogTitle>
                </DialogHeader>

                <Separator className="absolute left-0 bg-primary" />
                {open && (
                    <div className="flex h-[88%] flex-col gap-4 overflow-y-scroll bg-slate-50 px-5 py-7">
                        <NotificationContent />
                    </div>
                )}
            </SideDialogContent>
        </Dialog>
    );
}
